export const DESKTOP_CAPTURE_LABEL = "Capturing System + Microphone Audio";
